import { Shortcut, RicosPluginToolbarNames } from 'ricos-types';
import { Decoration_Type, RICOS_LINK_TYPE, RICOS_ANCHOR_TYPE } from 'wix-rich-content-common';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import { ADD_LINK_BUTTON } from './dataHooks.js';
import { DEFAULTS } from './defaults.js';
import { getToolbarButtons } from './get-toolbar-buttons.js';
import LinkIcon from './LinkIcon.js';
import LinkPanelComponent from './LinkPanelComponent.js';
import { LINK_TYPE } from './types.js';
import 'react';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-toolbars-ui';
import 'wix-rich-content-toolbars-v3';
import './toolbar/anchor-link-button.js';
import 'classnames';
import 'ricos-context';
import './url-link-button-bf9cda98.js';
import './style-inject.es-746bb8ed.js';
import './toolbar/url-link-button.js';
import 'ricos-content/libs/nodeUtils';
import './toolbar/edit-link-button.js';
import 'ricos-content-query';
import 'wix-rich-content-toolbars-modals';
import './toolbar/remove-link-button.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const FORMATTING_LINK_MODAL_ID = `${Decoration_Type.LINK}.modal`;
const pluginLink = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: LINK_TYPE,
    shortcuts: [
      Shortcut({
        name: Decoration_Type.LINK,
        description: "ShortcutsSheet_Formatting_Link",
        group: "ShortcutsSheet_Section_Formatting",
        keys: {
          macOs: "Meta+K",
          windows: "Ctrl+K"
        },
        enabled: true,
        command({ editorCommands, modalService }) {
          if (editorCommands.hasLinkInSelection()) {
            const link = editorCommands.getLinkDataInSelection();
            const linkType = (link == null ? void 0 : link.url) ? RICOS_LINK_TYPE : RICOS_ANCHOR_TYPE;
            editorCommands.deleteDecoration(linkType);
          } else {
            modalService.openModal(FORMATTING_LINK_MODAL_ID, {
              componentProps: {
                closeModal: () => modalService.closeModal(FORMATTING_LINK_MODAL_ID)
              },
              layout: "dialog"
            });
          }
        }
      })
    ],
    toolbar: {
      names: [RicosPluginToolbarNames.LINK],
      getButtons: getToolbarButtons,
      isVisible: (selection, editor) => {
        const isSelectionCollapsed = (selection2) => {
          const { from, to } = selection2;
          return to - from <= 0;
        };
        const isCollapsed = isSelectionCollapsed(selection);
        const isLinkInSelection = editor.getEditorCommands().hasLinkInSelection();
        return isCollapsed && isLinkInSelection;
      }
    },
    textButtons: [
      {
        id: Decoration_Type.LINK,
        type: "modal",
        presentation: {
          dataHook: ADD_LINK_BUTTON,
          tooltip: "TextLinkButton_Tooltip",
          icon: LinkIcon
        },
        attributes: {
          visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
          active: RESOLVERS_IDS.IS_TEXT_CONTAINS_LINK_OR_ANCHOR,
          disabled: RESOLVERS_IDS.IS_NODE_SELECTED
        },
        commands: {},
        modal: {
          id: FORMATTING_LINK_MODAL_ID,
          Component: LinkPanelComponent,
          layout: {
            desktop: "drawer",
            mobile: "fullscreen"
          }
        }
      }
    ]
  };
};

export { pluginLink };
//# sourceMappingURL=editor.js.map
